import React, { useEffect, useState } from "react";
import styled from "styled-components";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";

import TextStyles from "../../Constants/TextStyles";
import Colors from "../../Constants/Colors";
import ProjectServiceItem from "./ProjectServiceItem";

const ProjectServicesContainer = styled.div`
  padding: 1.875rem;
  border-radius: 0.75rem;
  border: solid 1px #b2b6c5;
  margin-bottom: 1.5rem;
  background-color: ${Colors.white};

  @media (max-width: 576px) {
    padding: 1.875rem 0.875rem;
  }
`;

function ProjectServices({
  register,
  fields,
  remove,
  append,
  control,
  Controller,
  currencySymbol,
  errors,
  sectionUpdate,
}) {
  const serviceError = errors.servicesList && errors.servicesList.length > 0;
  const editService = sectionUpdate === "service";

  const [open, setOpen] = useState(serviceError || editService);

  useEffect(() => {
    if (!serviceError) return;
    setOpen(serviceError);
  }, [serviceError]);

  return (
    <ProjectServicesContainer className="accordion" id="accordionExample">
      <div className="accordion-item border-0">
        <button
          className={`accordion-button gap-3 p-0 shadow-none bg-transparent ${
            open ? "" : "collapsed"
          }`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseTwo"
          aria-expanded={open ? true : false}
          aria-controls="panelsStayOpen-collapseTwo"
        >
          <img
            src="/images/services summary.svg"
            alt="zodot service icon"
            width={38}
          />

          <div>
            <TextStyles.FontSize20px>Services</TextStyles.FontSize20px>
            <TextStyles.GreyFont14px>
              Set name, description and cost of the services.
            </TextStyles.GreyFont14px>
          </div>
        </button>

        <div
          id="panelsStayOpen-collapseTwo"
          className={`accordion-collapse collapse ${open ? "show" : ""}`}
          aria-labelledby="panelsStayOpen-headingTwo"
        >
          {fields.map((item, index) => (
            <ProjectServiceItem
              key={item.id}
              index={index}
              fields={fields}
              register={register}
              remove={remove}
              control={control}
              Controller={Controller}
              currencySymbol={currencySymbol}
              errors={errors}
            />
          ))}

          <TextStyles.FontSize14px
            className="d-flex gap-2 align-items-center justify-content-end cursor-pointer"
            onClick={() =>
              append({
                service_name: "",
                service_rate: "",
                service_rate_type: "Flat fee",
                desc: "",
              })
            }
          >
            <AddCircleOutlineOutlinedIcon />
            <span>Add Another Service</span>
          </TextStyles.FontSize14px>
        </div>
      </div>
    </ProjectServicesContainer>
  );
}

export default ProjectServices;
